export enum TrackingEventType {
  ANALYTICS = 'analytics',
  MARKETING = 'marketing',
}
